import { useMemo } from 'react'
import { useQuery } from '@apollo/client'
import { MEMBERSHIP_JOURNEY_QUERY } from '../components/queries/member'
import { COACH_TOOLS_API } from '../apolloClient'

const transformPersonData = (person) => {
  if (!person) return null
  
  // Map mainProgramTypeCode to match V3 API behavior for backwards compatibility
  // V3 returns 'AP' for type, which is used to route to proper dashboard for Associates + Affiliates
  let programType = person.mainProgramTypeCode === 'AF' ? 'AP' : person.mainProgramTypeCode
  
  // For terminated users, mainProgramTypeCode may be null
  // Fallback to type on termination record
  if (!programType && person.termination?.type) {
    programType = person.termination.type === 'AF' ? 'AP' : person.termination.type
  }
  
  return {
    id: person.id,
    type: programType,
    class: person.classificationCode,
    curriculumVersion: person.educationLatestPgmProgram?.curriculumVersion,
    education: {
      currentLevel: person.educationCurrentLevel,
      mostRecentCompletedLevel: person.educationMostRecentCompletedLevel,
      levels: person.educationPgmProgramHistory?.map(program => ({
        levelCd: program.levelCode,
        completeCd: program.completeCode,
        startDate: program.startDate,
        endDate: program.endDate
      })) || []
    },
    prospect: person.prospect,
    committeeCodes: person.committeeCodes || [],
    reciprocityEligible: person.reciprocityEligible,
    gptpSuspension: person.gptpSuspension,
    suspended: person.suspended,
    termination: person.termination
  }
}

export const useMembershipJourney = () => {
  const { data, loading, error, refetch } = useQuery(MEMBERSHIP_JOURNEY_QUERY, {
    context: {
      api: COACH_TOOLS_API
    },
    fetchPolicy: 'cache-and-network'
  })

  const person = useMemo(() => transformPersonData(data?.me), [data?.me])

  return {
    person,
    loading,
    error,
    refetch
  }
}
